import { GlobalService } from 'src/app/global.service';
import { Component, OnInit } from '@angular/core';
import { HttpService } from 'src/app/http.service';
import { ThemePalette, ProgressSpinnerMode, MatDialog } from '@angular/material';
import { PdfPreviewComponent } from 'src/app/pdf-preview/pdf-preview.component';
import { DomSanitizer } from '@angular/platform-browser';


@Component({
  selector: 'app-govt-json',
  templateUrl: './govt-json.component.html',
  styleUrls: ['./govt-json.component.scss']
})
export class GovtJsonComponent implements OnInit {
  from_date: any = null;
  to_date: any = null;
  title: any;
  input_type = 'date';
  bill_number: any = null;

  constructor(private httpService: HttpService, private global: GlobalService) {
    this.title = this.global._active_display_name;
  }

  getdisableCheck() {
    if (this.input_type == 'date') {
      if (this.from_date == null || this.to_date == null) {
        return true
      } else {
        return false
      }
    } else {
      if (this.bill_number == null || this.bill_number == '') {
        return true
      } else {
        return false
      }

    }
  }
  getClicked() {
    let data_dict = {
      'from_date': this.from_date,
      'to_date': this.to_date,
      'bill_number': this.bill_number,
      'input_type': this.input_type
    }
    this.httpService.serveGovtJson(data_dict).subscribe((data : any = []) => {
      console.log(data);
      if (data.length == 0) {
        alert('No Data Available!!');
        return false
      } else {
        const c = JSON.stringify(data);
        var fileName = 'Final.json'
        if (this.input_type == 'date') {
          fileName = 'Govt - ' + this.from_date + '-' + this.to_date + '.json'
        } else {
          fileName = 'Govt - ' + this.bill_number + '.json'

        }
        const file = new Blob([c], {type: 'text/json'});
        var a = document.createElement("a")
        var url = URL.createObjectURL(file);
        a.href = url;
        a.download = fileName;
        // document.body.appendChild(a);
        a.click();
        // setTimeout(function() {
        //     document.body.removeChild(a);
        //     window.URL.revokeObjectURL(url);
        // }, 0);
      }

    }, (error) => {
      console.error(error)
    });
  }

  ngOnInit() {
  }

}
